import global from "../global.js";
const log = global.log.getLogger("f_mtac.ui.LoadingMediaArea");
log.setLevel(log.levels.WARN);

const LoadingMediaArea = function () {
    var {Modal} = window.f_mtac_theme;
    var loading_area_modal;

    let interaction_end = () => {
        loading_area_modal.hide();
        $("body").off("click.loading_media_area.btn", "#loading_media_area .btn");
    };
    this.interaction = null;
    this.interact = function ({tip = ""}) {
        loading_area_modal = new Modal(document.getElementById("loading_media_area"), {
            backdrop: "static", // avoid closing window when clicking outside
            keyboard: false
        });
        $("#loading_media_area .tip").html(tip); // AGPOC-4659: use .html() for special characters

        return new Promise((resolve) => {
            let handlers = {
                cancel: async () => {
                    // do not close the window immediately as the abort function may take few seconds
                    // put message "Cancelling" to inform user that cancelling is ongoing
                    $("#loading_media_area .tip").html(global.internationalization.text("media.Media-cancel-in-progress"));
                    await global.server.abort();
                    global.server.uploadingCancelled = true;
                    resolve(false);
                }
            };
            loading_area_modal.show();
            $("body").on("click.loading_media_area.btn", "#loading_media_area .btn", (event) => {
                handlers[$(event.currentTarget).data("method")]();
            });
            this.interaction = {
                close: () => {
                    resolve();
                    interaction_end();
                    this.interaction = null;
                }
            };
        });
    };
};
export default new LoadingMediaArea();
